import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class OpenReadmeService {

  $openReadMe = new BehaviorSubject<boolean>(null);
  $openEntry = new BehaviorSubject<any>(null);

  $reload = new BehaviorSubject<boolean>(null);

  private previous = null;

  constructor() {
  }

  public openReadMe(entry?) {
    if (this.previous && entry.name === this.previous) {
      this.$openReadMe.next(false);
      this.previous = null;
    } else {
      this.$openReadMe.next(true);
      this.$openEntry.next(entry);
      this.previous = this.$openEntry.getValue() ? this.$openEntry.getValue().name : null;
    }
  }

  public reloadReadMes() {
    this.$reload.next(true);
  }

}
